<template>
    <div>
        <div class="topbar topbar__dashboard">
            <div class="topbar__dashboard__inner">
                <div class="row align-items-baseline">
                    <div class="col-12 d-flex flex-wrap">

                        <div class="topbar__selectbox topbar__selectbox--duration">
                            <b-dropdown :text="`${selectedPeriodLabel}`" class="topbar__selectbox__item">
                                <b-dropdown-item
                                    v-for="period in periods"
                                    :key="period.value"
                                    :active="selectedPeriod == period.value"
                                    @click="handleSelectPeriod(period)"
                                >{{ period.label }}</b-dropdown-item>
                            </b-dropdown>
                        </div>

                        <div class="topbar__selectbox topbar__selectbox--user">
                            <b-dropdown :text="userType.label" class="topbar__selectbox__item">
                                <b-dropdown-item
                                    v-for="type in userTypes"
                                    :key="type.value"
                                    :active="type.value == userType.value"
                                    @click="handleSelectUserType(type)"
                                >{{ type.label }}</b-dropdown-item>
                            </b-dropdown>
                        </div>

                        <div class="topbar__selectbox">
                            <FilterByTrackers
                                ref="filterByTrackers"
                                @changed="trackersFilterChanged"
                            />
                        </div>

                        <ul class="topbar__side actions-list">
                            <li v-if="showSaveFilter"><a class="topbar__side__save" @click="openSaveFilter">Save As Preset</a></li>
                            
                            <template v-if="showPresets">
                                <li>
                                    <b-dropdown v-if="savedFilters.length" :text="loadPresetLabel" class="topbar__side__actions topbar__presets">
                                        <b-dropdown-item v-if="this.savedFilter" @click="resetFilters" class="default-preset">
                                            Reset To Default
                                        </b-dropdown-item>
                                        <b-dropdown-item v-for="(item, index) in savedFiltersList" @click="savedFilter = item" :key="index">
                                            {{item.name}}
                                        </b-dropdown-item>
                                        <b-dropdown-item class="manage-presets" @click="openManageSavedFilters">
                                            Manage Saved Presets
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </li>
                                <li v-if="$store.state.user.is_admin">
                                    <a @click="$refs.customizeHomepage.open()" class="link link--dashboard">Customize Homepage</a>
                                </li>
                            </template>
                            <template v-else>
                                <li>
                                    <a @click="resetFilters" class="topbar__side__clear">Clear Selected</a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <main class="main main--dark main--dashboard">
            <div class="content">
                <div v-for="(section, index) in layout" :key="index">
                    <dashboard v-if="section == 'dashboard' && filtersSet" @customize="customizeDashboard" :selectedPeriod="selectedPeriod" :userType="userType" :trackers="trackersIds" @unselectTracker="unselectTracker"></dashboard>
                    <tasks v-if="section == 'tasks'" v-on:loaded="loadAfterTasks"></tasks>
                    <startups v-if="section == 'startups'" :selectedPeriod="selectedPeriod" :userType="userType.value"></startups>
                    <searches v-if="section == 'searches'" :selectedPeriod="selectedPeriod" :userType="userType.value"></searches>
                    <trackers v-if="section == 'trackers'" :selectedPeriod="selectedPeriod" :userType="userType.value" :trackers="trackersIds"></trackers>
                    <users v-if="section == 'users'" ref="users" :selectedPeriod="selectedPeriod" :userType="userType.value"></users>
                </div>

            </div>

            <aside class="aside">
                <div class="aside__inner">
                    <div class="aside__inner__section">
                        <div class="image-block-wrapper align-items-start">
                            <div class="image-block image-block--mds mb-3">
                                <img :src="LogoHelper.getLogo($store.state.user.company_logo)" alt="img"/>
                            </div>
                            <div>
                                <h4 class="heading4">{{ $store.state.user.company_name }}</h4>
                                <p class="m-0 mb-4"><a :href="$store.state.user.company_url" target="_blank">{{$store.state.user.company_website}}</a></p>
                            </div>
                        </div>

                        <template v-if="false && $store.getters.isEnterprise"><p class="m-0">Enterprise</p></template>

                        
                        <!--<div v-if="$store.state.user.company_profile_text && $store.state.user.company_profile_text.length" v-html="$store.state.user.company_profile_text"></div>-->
                        
                        <div class="card card--bordered">
                            <p class="knowledgebase-text">Learn how to use SwitchPitch features</p>
                            <a class="button button--bordered--without--icon" href="https://switchpitch.document360.io/" target="_blank">
                                View Knowledgebase
                            </a>
                        </div>

                        <div v-if="$store.state.user.company_id !== constants.companyPfizer" class="card card--bordered card--user">
                            <div class="card--user__inner">
                                <div class="card--user__image"></div>

                                <div>
                                    <h6 class="heading6">Natasha Braun</h6>
                                    <p>Account Manager</p>
                                </div>
                            </div>

                            <div class="card--user__controls">
                                <a href="http://calendly.com/natasha-switchpitch" target="_blank" class="link-schedule" @click="scheduleMeeting">Schedule Meeting</a>
                                <a href="javascript:void(0)" class="link-envelope" @click="$refs.messageModal.show()">Send Message</a>
                            </div>
                        </div>

                        <!--            <p>Founded on 2012 | Enterprise <a href="#">switchpitch.com</a></p>-->
                        <!--            <p>Washington, District Of Columbia, 20007, United States, North America</p>-->
                        <!--            <p>SwitchPitch Profile Public URL: <a href="#">connect.switchpitch.com/companylinknamegoeshere/32324</a></p>-->

                        <div v-if="$store.state.accountType != 'free' && analystHours.loaded && analystHours.hasAnalyst" class="block-hours">

                            <header class="block-hours__header">
                                <h4 class="heading4">Analyst Hours</h4>
                                <p>{{analystHours.left}}h remaining</p>
                            </header>

                            <p v-if="!analystHours.left" class="text-center">You have no analyst hours.</p>

                            <div class="progress-wrapper" v-if="analystHours.percents">
                                <span class="time-badge" :class="'time-badge--' + analystHours.plan"></span>
                                <div class="progress">
                                    <div class="progress-bar" :class="'progress-bar--' + analystHoursPercentsColor" role="progressbar" :style="{'width': analystHours.percents + '%'}" :aria-valuenow="analystHours.percents" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>

                            <button class="button button--hours button--bordered--with--icon mb-2" @click="addAnalystHours">Add Analyst Hours</button>
                            <button v-if="analystHours.left" @click="$refs.analystMessageModal.show()" class="button button--bordered--with--icon button--new">New Project/Contact</button>

                        </div>

                        <add-analyst-hours
                            ref="addAnalystHours"
                            v-on:analyst-hours-added="getAnalystHours"
                        >
                        </add-analyst-hours>

                    </div>

                    <div v-if="lastVisitedStartups.length" class="aside__inner__section">
                        <h4 class="heading4">Recently Viewed</h4>

                        <ul class="rows-list rows-list--secondary">
                            <li v-for="(startup, index) in lastVisitedStartups" :key="index">
                                <figure class="image-block image-block--xs">
                                    <img :src="LogoHelper.getLogo(startup.logo_url)" alt="img"/>
                                </figure>
                                <div>
                                    <h5 class="heading5"><a :href="'/startups/' + startup.id" target="_blank">{{ startup.name }}</a></h5>
                                    <p>Viewed
                                        <template v-if="startup.viewed== 'today'">today</template>
                                        <template v-else>{{ startup.viewed }} ago</template>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>
        </main>

        <add-task
            v-if="$store.state.canLoadGlobalComponents"
            ref="addTask"
            prefix="-dashboard"
        >
        </add-task>

        <message-modal
            id="enterprice-message-modal"
            ref="messageModal"
            title="Message Account Manager"
        ></message-modal>

        <message-modal
            id="analyst-message-modal"
            ref="analystMessageModal"
            title="Message Analyst"
            type="analyst"
        ></message-modal>

        <SaveFilter
            ref="saveFilter"
            :filter="filter"
            :filtersList="savedFilters"
            v-on:saved-filters-changed="savedFiltersChanged"
            v-on:saved-filter-created="savedFilterCreated"
        >
        </SaveFilter>

        <CustomizeHomepage
            ref="customizeHomepage"
            @customizeDashboard="customizeDashboard"
        />

        <CustomizeDashboard
            ref="customizeDashboard"
            @modalClosed="() => {
                $refs.customizeHomepage.open()
            }"
        />
    </div>
</template>

<script>
import dashboard from "@/services/dashboard.service"
import AddAnalystHours from '@/components/subscriptions/AddAnalystHours'
import team from "@/services/team.service";
import analyst from "@/services/analyst.service";
import MessageModal from "@/components/MessageModal";
import CustomizeHomepage from "@/views/enterprise/Home/components/CustomizeHomepage";
import {mapActions, mapGetters} from "vuex"

import Highcharts from "highcharts";
import NoDataModule from "highcharts/modules/no-data-to-display";
import SaveFilter from "@/components/SaveFilter.vue";
import savedFilters from "@/services/saved-filters.service";
import FilterByTrackers from "@/components/widgets/FilterByTrackers.vue";

NoDataModule(Highcharts);

export default {
    data() {
        return {
            defaultPeriod : this.$store.state.user.company_id == this.constants.companyColgate ? "all" : "90",
            defaultPeriodLabel: this.$store.state.user.company_id == this.constants.companyColgate ? "All time" : "Last 90 days",

            selectedPeriod: "",
            selectedPeriodLabel: "",
            filtersSet: false,

            periods: this.constants.commonFilterPeriods,

            trackersIds: [],

            userType: {
                value: 'all',
                label: 'All users'
            },

            userTypes: [
                {
                    value: 'all',
                    label: 'All users'
                },

                {
                    value: 'groups',
                    label: 'My groups'
                },
                {
                    value: 'my',
                    label: 'Only me'
                },
            ],

            groups: [],

            lastVisitedStartups: [],

            analystHours: {
                loaded: false,
                hasAnalyst: false,
                left: 0,
                plan: "",
                percents: 0,
            },

            showSaveFilter: false,
            showPresets: true,
            savedFilters: [],
            savedFiltersList: [],
            savedFilter: null,
            updateDefault: true,
            watchFilterChange: false,
        }
    },

    components: {
        FilterByTrackers,
        SaveFilter,
        AddAnalystHours,
        CustomizeHomepage,
		Tasks: () => import('@/views/enterprise/Home/components/Tasks'),
        AddTask: () => import("@/components/tasks/EditTask"),
		Searches: () => import('@/views/enterprise/Home/components/Searches'),
		Startups: () => import('@/views/enterprise/Home/components/Startups'),
		Trackers: () => import('@/views/enterprise/Home/components/Trackers'),
        Dashboard: () => import("@/views/enterprise/Home/components/Dashboard"),
        Users: () => import("@/views/enterprise/Home/components/Users"),
        CustomizeDashboard: () => import("@/views/enterprise/Home/components/CustomizeDashboard"),
        MessageModal,
    },

    watch: {
        savedFilter() {

            if (this.savedFilter) {
                this.showSaveFilter = false
                this.watchFilterChange = false

                let filter = JSON.parse(this.savedFilter.filter)
                let selectedPeriod = this.periods.find(period => filter.period == period.value)

                if (selectedPeriod) {
                    this.selectedPeriod = selectedPeriod.value;
                    this.selectedPeriodLabel = selectedPeriod.label;
                }

                this.userType = this.userTypes.find(userType => filter.userType == userType.value)

                this.$refs.filterByTrackers.setTrackers(filter.trackers)

                if (this.updateDefault) {
                    savedFilters.updateDefault(this.savedFilter.id)
                }

                this.updateDefault = true

                this.$nextTick(() => {
                    this.watchFilterChange = true
                })
            }
        },

        filter() {
            if (this.watchFilterChange) {
                this.showSaveFilter = true
                this.showPresets =  false
            }
        },
    },

    computed: {
        ...mapGetters({
            layout: 'homepage/layout',
            foldersTrackersForFilter: 'foldersTrackersList',
            foldersTrackersLoaded: 'foldersTrackersLoaded',
        }),

        filter() {
           return {
               period: this.selectedPeriod,
               userType: this.userType.value,
               trackers: this.trackersIds,
           }
        },

        analystHoursPercentsColor() {
            if (this.analystHours.percents > 50) {
                return 'green'
            }
            else if (this.analystHours.percents > 20) {
                return 'yellow'
            }
            else {
                return 'red'
            }
        },

        loadPresetLabel() {
            if (this.savedFilter) {
                return this.savedFilter.name
            }
            else {
                return "Load Preset"
            }
        }
    },

    mounted() {
        this.selectedPeriod = this.defaultPeriod
        this.selectedPeriodLabel = this.defaultPeriodLabel

        this.$nextTick(() => {
            this.watchFilterChange = true
        })

        this.$store.watch(state => {
            if (state.accountType != 'premium') {
                this.loadAfterTasks()
            }
        })

        if (this.$store.state.user.is_admin) {
            team.getGroupsList().then(response => {
                this.groups = response.data
            })
        }

        this.fetchFoldersTrackers()

        this.$store.watch(() => {
            if (this.foldersTrackersLoaded) {
                this.getSavedFilters(0, true)
            }
        })

        if (!this.layout.includes('tasks')) {
            this.loadAfterTasks()
        }
    },

    methods: {
        ...mapActions(['fetchFoldersTrackers']),
        async updateAll() {
            const response = await dashboard.getWidgetData('LastVisitedStartups')
            this.lastVisitedStartups = response.data
        },

        getAnalystHours() {
            analyst.getAnalystHoursLeft().then(response => {
                this.analystHours.hasAnalyst = response.data.has_analyst

                if (this.analystHours.hasAnalyst) {
                    this.analystHours.left = response.data.hours_plan
                    this.analystHours.percents = response.data.percent_left
                    this.analystHours.plan = response.data.plan_name
                    this.analystHours.loaded = true
                }
            })
        },

        loadAfterTasks() {
            this.updateAll()
            this.getAnalystHours()
            this.$store.commit('setCanLoadGlobalComponents', true)
        },

        addAnalystHours() {
            this.$refs.addAnalystHours.open()
        },

        scheduleMeeting() {
            window.dataLayer.push(
                {
                    "event":"schedule meeting clicked"
                }
            );
        },

        handleSelectPeriod(period) {
            this.selectedPeriod = period.value;
            this.selectedPeriodLabel = period.label;
        },

        handleSelectUserType(userType) {
            this.userType = userType;
        },

        unselectTracker(trackerId) {
            this.$refs.filterByTrackers.unselectTracker(trackerId)
        },

        resetFilters() {
            this.watchFilterChange = false
            this.selectedPeriod = this.defaultPeriod
            this.selectedPeriodLabel = this.defaultPeriodLabel

            this.userType = {
                value: 'all',
                label: 'All users'
            }

            this.$refs.filterByTrackers.clearTrackers()
            this.savedFilter = null
            this.showSaveFilter = false

            savedFilters.updateDefault(null)

            this.$nextTick(() => {
                this.watchFilterChange = true
                this.showPresets = true
            })
        },

        openSaveFilter() {
            this.$refs.saveFilter.openEdit()
        },

        openManageSavedFilters() {
            this.$refs.saveFilter.openManage()
        },

        savedFilterCreated(filterId) {
            this.getSavedFilters(filterId)
        },

        savedFiltersChanged() {
            this.getSavedFilters()
        },

        getSavedFilters(currentFilterId = 0, loadDefault = false) {
            savedFilters.getList().then(response => {
                this.savedFilters = response.data
                this.savedFiltersList = this.savedFilters.map(group => group.items).flat()

                if (this.savedFiltersList.length) {

                    if (currentFilterId) {
                        this.savedFilter = this.savedFiltersList.find(item => item.id == currentFilterId)
                    }
                    else if (loadDefault) {
                        let defaultFilter = this.savedFiltersList.find(item => item.is_default)

                        if (defaultFilter) {
                            this.updateDefault = false
                            this.savedFilter = defaultFilter
                        }
                    }
                    else if (this.savedFilter) {
                        let saved = this.savedFiltersList.find(item => item.id == this.savedFilter.id)
                        if (saved) {
                            this.savedFilter = saved
                        }
                        else {
                            this.resetFilters()
                        }
                    }

                    this.showPresets = true
                }

                this.filtersSet = true
            })
        },

        customizeDashboard() {
            this.$refs.customizeDashboard.open()
        },

        trackersFilterChanged(trackers) {
            this.trackersIds = trackers
        }
    }
}
</script>
